const roles = {
    SUPER_ADMIN: {
        slug_name: "SUP_ADM",
        prefix: 'admin'
    },
    ADMIN: {
        slug_name: "ADMIN",
        prefix: 'admin'
    },
    DEMO: {
        slug_name: "DEMO",
        prefix: 'demo'
    },
    VIEWER: {
        slug_name: "VIEWER",
        prefix: 'admin'
    },
    PRE_KYC: {
        slug_name: "PRE_KYC",
        prefix: 'partner'
    },
    END_USER: {
        slug_name: "END_USER",
        prefix: 'partner'
    },
    OPERATION_USER: {
        slug_name: "OPERATION_USER",
        prefix: 'admin'
    },
    INQ_MANAGER: {
        slug_name: "INQ_MANAGER",
        prefix: "admin"
    },
    ON_BOARDING: {
        slug_name: "ON_BOARDING",
        prefix: "onboarding"
    }
}
export default roles;